import React from 'react'
// libs
import { useSearchParams } from 'react-router'
// components
import { IconButton } from 'components/UI'
// icons
import TableViewIcon from '@mui/icons-material/TableView'

const ToggleTableTreeButton: React.FC = () => {
  const [searchParams, setSearchParams] = useSearchParams()

  const isTableTree = searchParams.get('tableTree') === 'true'

  const handleToggle = () => {
    const next = new URLSearchParams(searchParams)

    if (isTableTree) {
      next.delete('tableTree')
    } else {
      next.set('tableTree', 'true')
    }

    setSearchParams(next)
  }

  return (
    <IconButton onClick={handleToggle} isActive={isTableTree} description='Change View Mode'>
      <TableViewIcon />
    </IconButton>
  )
}

export default ToggleTableTreeButton
